var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap--sub"
  }, [_c('sub-visual', {
    class: _vm.className,
    attrs: {
      "visual": _vm.title
    }
  }), _c('div', {
    staticClass: "contents"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('v-row', [_c('v-col', [_vm.isOrganization ? _c('view-organization', {
    attrs: {
      "expert": _vm.expert
    }
  }) : _vm._e(), _vm.isSupporter ? _c('view-supporter', {
    attrs: {
      "expert": _vm.expert
    }
  }) : _vm._e()], 1), _c('v-col', {
    staticClass: "py-6",
    attrs: {
      "cols": "3"
    }
  }, [_c('view-avatar', {
    attrs: {
      "expert": _vm.expert
    }
  })], 1)], 1), _vm.isOrganization ? _c('view-worker', {
    attrs: {
      "expert": _vm.expert
    }
  }) : _vm._e(), _vm.isSupporter ? _c('view-contact', {
    model: {
      value: _vm.expert,
      callback: function callback($$v) {
        _vm.expert = $$v;
      },
      expression: "expert"
    }
  }) : _vm._e(), _c('view-descriptions', {
    model: {
      value: _vm.expert,
      callback: function callback($$v) {
        _vm.expert = $$v;
      },
      expression: "expert"
    }
  }), _c('view-card', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "rounded-0",
    attrs: {
      "outlined": "",
      "color": "grey darken-1"
    },
    on: {
      "click": _vm.goList
    }
  }, [_vm._v("리스트")])], 1), _c('v-spacer'), _vm.isExpert ? _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "rounded-0",
    attrs: {
      "outlined": "",
      "color": "secondary darken-1",
      "to": "/experts/modify"
    }
  }, [_vm._v("수정하기")])], 1) : _vm._e()], 1)], 1)], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }